module.exports = __webpack_public_path__ + "static/img/05.db58d02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/eggenberger/05.jpg
// module id = 365
// module chunks = 1